import { render, staticRenderFns } from "./ArticleTypeSelectBox.vue?vue&type=template&id=a21ba098&"
import script from "./ArticleTypeSelectBox.vue?vue&type=script&lang=js&"
export * from "./ArticleTypeSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports